<template>
    <div class="text-center">
        <v-btn v-if="file !== null" small icon @click="showFileDialog">
            <v-icon small color="success">mdi-file-find</v-icon>
        </v-btn>
        <v-btn small icon @click="changePhoto" title="Загрузить фото" v-if="(!!showAccount || !!showFranch) && stage !== 'C30:WON'">
            <v-icon small>mdi-dots-horizontal</v-icon>
        </v-btn>
        <viewer :options="options" :images="imageSource" @inited="inited" class="viewer" ref="viewer">
            <template slot-scope="scope">
                <img width="10" height="10" v-for="(image, index) in scope.images" :key="index" style="display: none;" :src="image" >
            </template>
        </viewer>
        <v-dialog v-model="selectFileDialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                    <span class="headline">Загрузите файл</span>
                </v-card-title>
                <v-card-text height="300px">
                    <v-container>
                        <v-row>
                            <v-col cols="8"><v-file-input :loading="showLoader" accept="image/jpeg, image/pjpeg, image/png, image/gif" v-model="newPhotoFile" multiple placeholder="Загрузить фото"></v-file-input></v-col>
                            <v-col cols="4"><v-btn :disabled="showLoader || newPhotoFile === null || newPhotoFile.length < 1" color="success" @click="loadPhoto">Загрузить</v-btn></v-col>
                        </v-row>
                    </v-container>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text :disabled="showLoader" @click="selectFileDialog = false">Закрыть</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
  import 'viewerjs/dist/viewer.css'
  import { component as Viewer } from 'v-viewer'
  import moment from 'moment'

  export default {
    name: 'stoFileLoader',
    components: { Viewer },
    props: ['value', 'mode', 'stage'],
    data() {
      return {
        showLoader: false,
        newPhotoFile: null,
        showFile: false,
        file: this.value,
        selectFileDialog: false,
        options: {
          loop: false,
          fullscreen: false,
          inline: false,
          button: false,
          navbar: false,
          title: false,
          toolbar: true,
          tooltip: false,
          movable: true,
          zoomable: true,
          rotatable: true,
          scalable: false,
          transition: false,
          keyboard: true,
          // url: "data-source"
        }
      }
    },
    computed: {
      showAdminUI() {
        return this.mode === 'manager' || this.mode === undefined
      },
      showAccount() {
        return this.mode === 'account'
      },
      showFranch() {
        return this.mode === 'franch'
      },
      showUK() {
        return this.mode === 'uk'
      },
      imageSource() {
        if(!Array.isArray(this.file)) {
          if(this.file !== null) return (this.file.indexOf('https://fit-service-bitrix.ru') > -1) ? [this.file] : [`https://sbotapi.fitauto.ru/v15/shopper/viewfile/${this.file}`]
        } else {
          return this.file
        }
      },
    },
    methods: {
      loadPhoto: async function() {
        let data = []
        if(!Array.isArray(this.newPhotoFile)) {
          console.log('is not array')
          data.push(this.newPhotoFile)
        } else {
          console.log('is array', this.newPhotoFile)
          data = this.newPhotoFile
        }

        for(let image of data) {
          let formData = new FormData()
          let uploadURL, field
          this.showLoader = true
          try {
            const r = await this.$http.post(`${this.$store.getters.bxapi}disk.folder.uploadfile?id=80614`)
            if(r.data.result) {
              uploadURL = r.data.result.uploadUrl
              field = r.data.result.field
              formData.append(field, image, `${moment().format('x')}${image.name}`)
            }
          } catch (e) {
            console.log('eeeeeee', e)
          }

          if(field !== undefined) {
            try {
              const r = await this.$http.post(uploadURL,
                formData, {
                  headers: {
                    'Content-Type': 'multipart/form-data'
                  }
                }
              )


              if(Array.isArray(this.file)) {
                this.file.push(r.data.result.DOWNLOAD_URL)
              } else {
                this.file = [r.data.result.DOWNLOAD_URL]
              }
            } catch (e) {
              console.log('uplloadddd', e)
            }
          }

        }

        console.log('multi uplaod', this.file)

        this.selectFileDialog = false
        this.showFile = false
        this.newPhotoFile = null
        this.showLoader = false
        this.$emit('input', this.file)
        this.$nextTick(function () {
          this.$emit('change')
        })

      },
      inited (viewer) {
        this.$viewer = viewer
      },
      setFile(newFile) {
        this.file = newFile
        this.selectFileDialog = false
        this.showFile = false
        this.newPhotoFile = null
        this.showLoader = false
        this.$emit('input', this.file)
        this.$nextTick(function () {
          this.$emit('change')
        })
      },
      changePhoto() {
        this.selectFileDialog = true
      },
      showFileDialog () {
        console.log('imagez', this.images)
        this.$viewer.show()

      },
    }
  }
</script>

<style scoped>

</style>
